import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { logout } from '../actions/auth';
import { Link } from 'react-router-dom';
import './profile.css'


export class Logout extends Component {

  static propTypes = {
    logout: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool,
    auth: PropTypes.object.isRequired,
  };

  onClick = (e) => {
    e.preventDefault();
    this.props.logout();
  };

  onChange = (e) => this.setState({ [e.target.name]: e.target.value });

  render() {
    const { user } = this.props.auth;
    return (
        <div className="profile-container container-sm">
            <div className="d-flex justify-content-center profile-title">
              <p className="headline">Profile</p>
            </div>
                <span className="button">Username:</span>
                <span data-testid="username">{user ? user.username : ''}</span>
                <div>
                    <Link className="profile-link button" to={'/change-password'}>Change Password</Link>
                </div>
            <div className="d-flex justify-content-center">
                <button className="button-logout button" onClick={this.onClick}>
                Logout
                </button>
            </div>
        </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  auth: state.auth
});

export default connect(mapStateToProps, { logout })(Logout);